import { serverBus} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import Global  from '@/scripts/Global'
import ChannelApi from './api/channel.api';
import VueSignals from './VueSignals';
import WebRTCConfig from './WebRTC/WebRTCConfig'
import SignalingServer from './WebRTC/SignalingServer';


//https://webrtc.org/
//https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection
//https://developer.mozilla.org/en-US/docs/Web/API/MediaStream

export default {
    name: 'CallerPeer',
    data (){
        return {
            callState: 'none',
            loggedInUserId: SessionManager.getLoggedInUserId(),
            CallChannel: SessionManager.getActiveChannel(),
            CallingUser: null,
            callFromUserId: '',
            callChannelId: null,
            replacedCall: false,
            callTime: 0,
            elapsedTime:"00:00",
            allowVideo: false,
            microphoneMuted: false,
            callUserIds: [],
            askcallUserIds: [],
            RTCConnections: new Map(),
            RTCDesc: new Map(),
            localVideoStream: null,
            localVideoStreamType: '',
            localAudioStream: null,
            RTCAllTracks: [],
            RTCNotAcceptedTracks: [],
            dontShowRing: false,
            BullyAlgorithm: false,
            RTCBackupDesc:[],
            RTCBackupConnections: [],
            tryReConnect: [],
            sentAllTracks: [],
            RTCAnCount: 0,
            bullyStartedAt: 0,
            bullyEndedAt: 0,
            neededTime:0,
            callerAudio: new Audio(`${process.env.BASE_URL}caller-ringtone.mp3`),
            inCall: false,
        }
    },
    computed: {
        isELectron() {
          return Global.isELectron()
        }
    },
    mounted(){

        serverBus.$on(VueSignals.LOGGED_IN_USER, () => {
            this.loggedInUserId =  SessionManager.getLoggedInUserId()
        })


        serverBus.$on("RTC_Call", (status) => {
            this.inCall = status
        })

        serverBus.$on(VueSignals.SOCKET_USER_STATUS_CHANGED, (result) => {
            // && users_ids.indexOf(result.data.user_id) > -1
            if(result.data.status == "offline" ){
                Global.globalValue("CALL_REMOVE_USER", result.data.user_id)
                if(this.RTCConnections.has(result.data.user_id)){
                    this.RTCConnections.get(result.data.user_id).close()
                    this.RTCConnections.delete(result.data.user_id)
                    this.callUserIds.splice(this.callUserIds.indexOf(result.data.user_id), 1)
                }
            }
        })

        serverBus.$on(WebRTCConfig.SOCKET_CALL_TIMEOUT, (data) => {
            if(this.callState != 'none'){
                Global.globalValue("rtc_call_banner_message_red", "Nobody answers")
                this.DeclineCall()
            }
        })

        serverBus.$on("SOCKET_CALL_USERS_TIMEOUTED", (data) => {
            Global.globalValue("CALL_GOT_USER_STATES", data)
        })

        serverBus.$on("DECLINE_USER_ID", (user_id) => {
            this.CleanRemoveUser(user_id)
            SignalingServer.DeclineCall(this.loggedInUserId,
                [user_id])
        })

        //@TODO check if the call is the initator
        serverBus.$on(WebRTCConfig.SOCKET_DECLINE_CALL, (data) => {
            if(this.loggedInUserId != data.creator_user_id){
                if(this.RTCConnections.has(data.creator_user_id)){
                    this.CleanRemoveUser(data.creator_user_id)
                    Global.globalValue("CALL_GOT_USER_STATES_DECLINE", data.creator_user_id)
                }

                if(this.callUserIds.length  == 0){
                    this.DeclineCall()
                }
            }
          })



        serverBus.$on("calculateCallerTime", () => {
            //@TODO STOP it at end
            // if(this.RTCConnections[users_ids[0]].iceConnectionState == "connected"){
                this.calculateCallTime()
            // }
        })

        serverBus.$on("shareLocalAudioStream", (data) => {
            this.localAudioStream = data
        })

        serverBus.$on("shareLocalVideoStream", (data) => {
            this.shareLocalVideoStream = data
        })

        serverBus.$on(WebRTCConfig.SOCKET_CREATE_JOIN_RTC_CALL, (data) => {
            if(this.loggedInUserId != data.creator_user_id &&
                this.callChannelId != null &&
                this.callChannelId == data.channel_id){


                if(typeof data.creator_user_id == Array){
                    for(let i =0; i <data.creator_user_id.length;i++){
                        this.CreatePeerConnection(data.creator_user_id[i], true, true)
                    }
                }else {
                    this.CreatePeerConnection(data.creator_user_id, true, true)
                }
            }else {
                this.callChannelId = data.channel_id
                this.BullyAlgorithm = true
                this.bullyStartedAt = new Date().getTime()
                console.log("notified to be a leader",this.bullyStartedAt  )
                this.CreatePeerConnection(data.creator_user_id, true, true)
                ChannelApi.join_call(this.callChannelId, this.loggedInUserId)
            }
        })

        serverBus.$on("invite_rtc_call", (user_ids) => {
            for(let i=0; i < user_ids.length;i++){
                this.CreatePeerConnection(user_ids[i], false, true)
                Global.globalValue("CALL_GOT_USER_STATES", user_ids[i])
            }
        })




        serverBus.$on("SOCKET_ICE_ERROR", (rtcData) => {
            if(rtcData.creator_user_id !=  this.loggedInUserId && this.tryReConnect.indexOf(rtcData.creator_user_id) < 0) {
                this.tryReConnect.push(rtcData.creator_user_id)
                // this.RTCConnections[rtcData.creator_user_id].close()
                // this.CleanRemoveUser(rtcData.creator_user_id)
                this.CreatePeerConnection(rtcData.creator_user_id, true, false)
            }
        })


        serverBus.$on("ScreenCall", (user_ids) => {
            this.askCallUserIds = user_ids
            this.ResetCallData()
            this.getRootWindow(window).navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
                this.localAudioStream = stream
                Global.globalValue("CALL_GOT_USER", {
                    "user_id": this.loggedInUserId,
                    "streamEvent":stream
                })
                this.RTCAllTracks.push({
                    "from_user": this.loggedInUserId,
                    "stream": stream
                })
                document.getElementById("audio1").srcObject = stream
                document.getElementById("audio1").muted = true
                this.callerAudio.loop = true
                this.callerAudio.play()

                this.createSignal()
            }).catch((error => {
                Global.globalValue("rtc_call_banner_message_red", "Please, Install a microphone or if it's already installed allow it")
                console.log(error)
            }))
        })

        serverBus.$on(WebRTCConfig.SOCKET_UPGRADE_CALL_FROM_CALLEE, (rtcData) => {
            if(rtcData.creator_user_id != this.loggedInUserId &&
                this.RTCConnections.has(rtcData.creator_user_id)){

                this.RTCConnections.get(rtcData.creator_user_id).setRemoteDescription(new RTCSessionDescription(rtcData.desc)).then(() => {
                    this.RTCConnections.get(rtcData.creator_user_id).createAnswer().then( answer => {
                        SignalingServer.UpgradeAnswerFromCaller(this.loggedInUserId,
                                                                rtcData.creator_user_id,
                                                                answer,
                                                                rtcData.desc,
                                                                [rtcData.creator_user_id])
                        this.RTCConnections.get(rtcData.creator_user_id).setLocalDescription(new RTCSessionDescription(answer)).then(() => {
                            //@check
                            // this.RTCConnections.get(rtcData.creator_user_id).createOffer().then((desc) => {
                            //     SignalingServer.UpgradeCall(this.loggedInUserId,
                            //                                 rtcData.creator_user_id,
                            //                                 desc,
                            //                                 [rtcData.creator_user_id])
                            //     this.RTCDesc.set(rtcData.creator_user_id, desc)
                            // })
                        })
                    }).catch(err => {
                        console.log(err)
                    })

                })
                this.RTCConnections.get(rtcData.creator_user_id).ontrack = (e) => {
                    this.track(e, rtcData.creator_user_id)
                }
            }
        })



        serverBus.$on(WebRTCConfig.SOCKET_ANSWER_ICE, (rtcData) => {
            if(this.loggedInUserId != rtcData.creator_user_id &&
            typeof this.RTCConnections.get(rtcData.creator_user_id) != 'undefined'){
                this.callFromUserId = rtcData.creator_user_id
                console.info("got an answer ICE")
                let ops = false
                try {
                  new RTCIceCandidate(rtcData.candidate)
                  ops = true
                } catch (error) {
                  ops = false
                }

                if(ops){
                    this.RTCConnections.get(rtcData.creator_user_id).addIceCandidate(rtcData.candidate).then( () => {
                            console.info("---------- add ICE success")
                        }).catch((err) => {
                            console.error("not added candidated " + err)
                            // Global.globalValue(WebRTCConfig.SOCKET_ANSWER_ICE, rtcData)
                        })
                    }
                }
        })

        serverBus.$on(WebRTCConfig.SOCKET_REC_USER_CALL, (rtcData) => {
            if(rtcData.creator_user_id != this.loggedInUserId){
                console.log("**** not accepted tracks", this.RTCNotAcceptedTracks)
                for(let i = 0; i < this.RTCNotAcceptedTracks.length;i++){
                    if(this.RTCNotAcceptedTracks[i].user_id == rtcData.creator_user_id &&
                        this.RTCNotAcceptedTracks[i].from_user == rtcData.rec_user_id){
                            this.RTCNotAcceptedTracks.splice(i, 1)
                            break
                    }
                }
            }
        })




        serverBus.$on(WebRTCConfig.SOCKET_CREATED_ANSWER, (rtcData) => {
            if(rtcData.desc.type == "answer" &&
                this.loggedInUserId != rtcData.creator_user_id &&
                this.RTCConnections.has(rtcData.creator_user_id)){
                    this.RTCConnections.get(rtcData.creator_user_id).setLocalDescription(new RTCSessionDescription(this.RTCDesc.get(rtcData.creator_user_id)))
                    .then(() => {
                        this.RTCConnections.get(rtcData.creator_user_id).setRemoteDescription(new RTCSessionDescription(rtcData.desc)).then(()=>{
                            this.callerAudio.pause()
                            if(this.callTime == 0){
                                this.calculateCallTime()
                            }

                        }).catch((err) => {
                            console.log("answer setRemoteDescription Error" + err)
                        })
                    })
                    .catch((err) => {
                        // Global.globalValue(WebRTCConfig.SOCKET_CREATED_ANSWER, rtcData)
                    })
            }
        })
    },
    methods: {
        iceCallback(event, user_id){
            if(event.candidate){
                SignalingServer.OfferICE(this.loggedInUserId,
                                        event.candidate,
                                        [user_id])
            }

        },
        iceCandidateError(e){
            console.log('The server ' + e.url +
            ' returned an error with code=' + e.errorCode + ':\n' +
            e.errorText + '\n')
        },
        createSignal(){
            ChannelApi.RTCCall(SessionManager.getActiveChannelId(), this.askCallUserIds).then(res=>{
                if(res.data.result && res.data.avaliable_user_ids.length > 0){
                    this.callUserIds = res.data.avaliable_user_ids
                    this.callState = 'ongoing'
                    Global.globalValue("SHOW_CONFERENCE_CHANNEL", SessionManager.getActiveChannelId())
                    Global.globalValue("SHOW_CONFERENCE", true)
                    Global.globalValue("CALL_INIT_USER_ID", this.loggedInUserId)
                    Global.globalValue("RTC_REMOVE_ANSWER", true)
                    Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
                    Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, true)
                    Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME,'conference')

                    this.callState = 'ringing'
                    this.CallingUser = SessionManager.getUser(this.callUserIds[0])
                    for(let i = 0 ; i < this.callUserIds.length ;i++){
                        this.CreatePeerConnection(this.callUserIds[i], false)
                    }

                    Global.globalValue("CALL_GOT_USER_STATES", res.data)
                }else if(res.data.result && res.data.avaliable_user_ids.length > 0){
                    Global.globalValue("rtc_call_banner_message_red", "No user is online")
                    Global.globalValue("inCall", false)
                    this.DeclineCall()
                }
                else {
                    if(res.data.reason == "channel_is_busy"){
                        let channel = SessionManager.getActiveChannel()
                        if(channel.direct){
                            Global.globalValue("rtc_call_banner_message_red", "User is busy")
                        }else {
                            Global.globalValue("rtc_call_banner_message_red", "Channel is busy")
                        }
                        Global.globalValue("inCall", false)
                        this.DeclineCall()
                    }
                }
            })
        },
        RTCStatus(e, user_id){
            if(!this.RTCConnections.has(user_id)){
                return
            }
            console.log("RTC Connection Send status ----> " + this.RTCConnections.get(user_id).iceConnectionState + " user -> " + SessionManager.getUser(user_id).username)
            if(this.RTCConnections.get(user_id).iceConnectionState == "failed"){
                this.CreatePeerConnection(user_id, true, true)
            }

            if(this.RTCConnections.get(user_id).iceConnectionState == "connected"){
                if(this.tryReConnect.indexOf(user_id) > -1 &&
                this.RTCConnections.get(user_id).signalingState == "stable"){
                    this.tryReConnect.splice(this.tryReConnect.indexOf(user_id), 1)
                }
                console.log("*******************")
                console.log(SessionManager.getUser(user_id).username + " is connected" )

                this.CheckTracks(user_id)
                console.log("needed", this.neededTime )


                if(this.bullyEndedAt == 0){
                    this.bullyEndedAt = new Date().getTime()
                    if(this.neededTime == 0){
                        this.neededTime = (this.bullyEndedAt - this.bullyStartedAt) /1000
                      }
                }


                if(this.BullyAlgorithm){
                    Global.globalValue("reconnecting_leader", false)
                    SignalingServer.ResendTracks(this.loggedInUserId, user_id)
                }
            }


            if(this.RTCConnections.get(user_id).iceConnectionState == "disconnected" ||
            this.RTCConnections.get(user_id).iceConnectionState == "closed" ||
            this.RTCConnections.get(user_id).iceConnectionState == "failed"){
                for(let i=0; i < this.RTCAllTracks.length;i++){
                    if(this.RTCAllTracks[i].from_user == user_id){
                        this.RTCAllTracks.splice(i, 1)
                    }
                }

                for(let i=0; i < this.RTCNotAcceptedTracks.length;i++){
                    if(this.RTCNotAcceptedTracks[i].from_user == user_id){
                        this.RTCNotAcceptedTracks.splice(i, 1)
                    }
                }
                this.callerAudio.pause()
            }
            console.log("RTC Signal status ----> " + this.RTCConnections.get(user_id).signalingState)
            console.log("RTC gathering Send status ----> " + this.RTCConnections.get(user_id).iceGatheringState)
        },
        DeclineCall(){
            ChannelApi.declineCall(this.callChannelId)
            this.callerAudio.pause()
            for (let [k, peer] of this.RTCConnections) {
                console.log("Key: " + k+ " is closed.")
                peer.close()
            }

            this.stopMedia()
            /** close peerConn */
            this.callState = "declined"
            Global.globalValue("SHOW_CONFERENCE", false)
            Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE,false)
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME,'channel_users')
            SignalingServer.DeclineCall(this.loggedInUserId,
                                        this.callUserIds)
            Global.globalValue("inCall", false)
            this.ResetCallData()
            Global.globalValue("RTC_Call", false)
            Global.globalValue("RTC_REMOVE_ANSWER", false)
        },
        stopMedia(){
            if(this.localAudioStream){
                this.localAudioStream.getTracks().forEach((track) => {
                  track.stop()
                })
            }
            if(this.localVideoStream != null){
                this.localVideoStream.getTracks().forEach((track) => {
                    track.stop()
                })
            }
        },
        track(e, user_id){
                this.callState = 'ongoing'
                this.RTCAllTracks.push({
                    "from_user": user_id,
                    "stream": e.streams[0]
                })

                Global.globalValue("CALL_GOT_USER", {
                    "user_id": user_id,
                    "streamEvent":e
                })

                for (let [key, peer] of this.RTCConnections) {
                    if (key != user_id && peer.iceConnectionState == "connected"){
                        try{
                            e.streams[0].getTracks().forEach(track => {
                                peer.addTrack(track, e.streams[0])
                            })
                        }catch(error){
                            console.log(error)
                        }

                        if(peer.signalingState == "stable"){
                            peer.createOffer().then((desc) => {
                                this.RTCDesc.set(key, desc)
                                SignalingServer.UpgradeCall(this.loggedInUserId,
                                                            user_id,
                                                            desc,
                                                            [key])
                            })
                        }
                    }else if (key != user_id && peer.iceConnectionState != "connected"){
                        this.RTCNotAcceptedTracks.push({
                            "from_user": user_id,
                            "user_id": key,
                            "stream": e.streams[0]
                        })
                    }
                }
        },
        screenshare(){
            if(this.localVideoStream != null && this.localVideoStreamType == 'screenshare'){
                this.localVideoStreamType = ''
                this.localVideoStream.getTracks().forEach(function(track) {
                    track.stop();
                })
                let singalArr = this.callUserIds
                singalArr.push(this.loggedInUserId)
                SignalingServer.DisableVideo(this.loggedInUserId, true, singalArr)
                this.localVideoStream = null
                return
            }
            this.localVideoStreamType = 'screenshare'
            // this.localVideoStream is empty and request screen share
            if(this.isELectron){
                if(!allowVideo){
                    navigator.webkitGetUserMedia({
                        audio:false,
                        video: {
                            mandatory:{
                                chromeMediaSource: 'desktop'
                            }
                        }
                    }, (gotStream) => {
                        this.allowVideo = true
                        let stream
                        if(typeof gotStream.streams == "undefined"){
                            stream = gotStream
                            stream.streams = [gotStream]
                        }
                        // console.log("call", stream)
                        this.localVideoStream = stream
                        this.addStream(stream, this.loggedInUserId)
                        Global.globalValue("CALL_GOT_USER", {
                            "user_id": this.loggedInUserId,
                            "streamEvent":stream
                        })
                        document.querySelector("#video_from_" + this.loggedInUserId).src = URL.createObjectURL(stream)
                        let singalArr = this.callUserIds
                        singalArr.push(this.loggedInUserId)
                        SignalingServer.DisableVideo(this.loggedInUserId, !allowVideo, singalArr)

                        }, (err) => {
                            console.log(err)
                        })
                }else{
                    this.allowVideo = false
                    Global.globalValue("CALL_GOT_USER", {
                        "user_id": this.loggedInUserId,
                        "streamEvent":null
                    })
                    let singalArr = this.callUserIds
                    singalArr.push(this.loggedInUserId)
                    SignalingServer.DisableVideo(this.loggedInUserId, !this.allowVideo, singalArr)
                }
                return
            }

            if (navigator.getDisplayMedia) {
                this.getRootWindow(window).navigator.getDisplayMedia({video: true}).then(stream => {
                    this.localVideoStream  = stream
                    this.addStream(stream, this.loggedInUserId)
                    Global.globalValue("CALL_GOT_USER", {
                        "user_id": this.loggedInUserId,
                        "streamEvent":stream
                    })
                });
            } else if (navigator.mediaDevices.getDisplayMedia) {
                this.getRootWindow(window).navigator.mediaDevices.getDisplayMedia({video: true}).then(stream => {
                    this.localVideoStream  = stream
                    this.addStream(stream, this.loggedInUserId)
                    Global.globalValue("CALL_GOT_USER", {
                        "user_id": this.loggedInUserId,
                        "streamEvent":stream
                    })
                });
            } else {
                this.getRootWindow(window).navigator.mediaDevices.getUserMedia({ video: {mediaSource: 'screen'}}).then(stream => {
                    this.localVideoStream  = stream
                    this.addStream(stream, this.loggedInUserId)
                    Global.globalValue("CALL_GOT_USER", {
                        "user_id": this.loggedInUserId,
                        "streamEvent":stream
                    })
                });
            }

            let singalArr = this.callUserIds
            singalArr.push(this.loggedInUserId)
            SignalingServer.DisableVideo(this.loggedInUserId, false, singalArr)

        },
        videoCall(){
            if(!this.allowVideo){
                this.localVideoStreamType = 'video'
                this.allowVideo = true
                this.getRootWindow(window).navigator.mediaDevices.getUserMedia({video: true}).then(stream => {
                    this.localVideoStream = stream
                    Global.globalValue("CALL_GOT_USER", {
                        "user_id": this.loggedInUserId,
                        "streamEvent":stream
                    })
                    this.addStream(stream, this.loggedInUserId)
                })
            }else {
                this.allowVideo = false
                if(this.localVideoStream != null){
                    this.localVideoStream.getTracks().forEach(function(track) {
                        track.stop();
                    });
                }
                Global.globalValue("CALL_GOT_USER", {
                    "user_id": this.loggedInUserId,
                    "streamEvent":null
                })
                // if(this.localVideoStream){
                //     this.localVideoStream.stop()
                //   }
            }
            let signalArr = this.callUserIds
            signalArr.push(this.loggedInUserId)
            SignalingServer.DisableVideo(this.loggedInUserId, this.allowVideo, signalArr)
        },
        microphoneClick(){
            if(!this.microphoneMuted){
              this.microphoneMuted = true
              this.localAudioStream.getTracks().forEach(function(track){
                  track.stop()
              })
              let signalArr = this.callUserIds
              signalArr.push(this.loggedInUserId)
              SignalingServer.DisableAudio(this.loggedInUserId, this.microphoneMuted, signalArr)
            }else {
                try {
                    this.getRootWindow(window).navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
                        this.localAudioStream = stream
                        Global.globalValue("CALL_GOT_USER", {
                            "user_id": this.loggedInUserId,
                            "streamEvent":stream
                        })
                        this.microphoneMuted = false
                        this.addStream(stream, this.loggedInUserId)
                        document.getElementById("audio1").srcObject = stream
                        document.getElementById("audio1").muted = true
                        let signalArr = this.callUserIds
                        signalArr.push(this.loggedInUserId)
                        SignalingServer.DisableAudio(this.loggedInUserId, this.microphoneMuted, signalArr)
                    })
                } catch (error) {
                    console.error(error)
                }
            }
        },

        addStream(gotStream, user_id){
            console.log(gotStream)
            if(typeof gotStream.streams != "undefined"){
                this.RTCAllTracks.push({
                    "from_user": user_id,
                    "stream": gotStream.streams[0]
                })
            }else {
                this.RTCAllTracks.push({
                    "from_user": user_id,
                    "stream": gotStream
                })
            }
            gotStream.getTracks().forEach(track => {
                for (let [key, peer] of this.RTCConnections) {
                    if (key != user_id){
                        peer.addTrack(track, gotStream)
                        // this.askForUpgrade(user_id)

                        if(peer.iceConnectionState == "connected" &&
                            peer.signalingState == "stable"){

                            peer.createOffer().then((desc) => {
                                SignalingServer.UpgradeCall(this.loggedInUserId,
                                                            user_id,
                                                            desc,
                                                            [key])
                                this.RTCDesc.set(key, desc)
                            })
                        }
                    }
                }
            })
        },
        pad ( val ) { return val > 9 ? val : "0" + val; },
        calculateCallTime() {
            this.elapsedTime = this.pad(parseInt(this.callTime/60,10)) // min
            this.elapsedTime += ":"
            this.elapsedTime +=  this.pad(++this.callTime%60)        // sec
            setTimeout( function(){
                Global.globalValue("calculateCallerTime", true)
            }, 1000);
        },
        CreatePeerConnection(user_id, join = false, addAllTracks = false){
            if(this.callUserIds.indexOf(user_id) < 0){
                this.callUserIds.push(user_id)
            }
            this.RTCConnections.set(user_id, new RTCPeerConnection(WebRTCConfig.stun_turn_servers))
            if(this.localAudioStream != null){
                this.localAudioStream.getTracks().forEach(track => {
                    this.RTCConnections.get(user_id).addTrack(track, this.localAudioStream)
                })
            }

            if(this.localVideoStream != null){
                this.localVideoStream.getTracks().forEach(track => {
                    this.RTCConnections.get(user_id).addTrack(track, this.localVideoStream)
                })
            }
            console.log('Created local peer connection object pc1');
            this.RTCConnections.get(user_id).onicecandidate =  (e) => {
                this.iceCallback(e, user_id)
            }
            this.RTCConnections.get(user_id).oniceconnectionstatechange =  (e) => {
                this.RTCStatus(e, user_id)
            }
            this.RTCConnections.get(user_id).onicegatheringstatechange =  (e) => {
                this.RTCStatus(e, user_id)
            }
            this.RTCConnections.get(user_id).onicecandidateerror = this.iceCandidateError
            this.RTCConnections.get(user_id).onnegotiationneeded = (e) => {
                console.log("***** negotation", e)
            }

            // Memorization of others tracks
            if(addAllTracks){
                for(let i = 0; i < this.RTCAllTracks.length;i++){
                    // if(this.RTCAllTracks[i].from_user != this.loggedInUserId){
                        // this.RTCAllTracks[i].stream.getTracks().forEach(track => {
                        //     try{
                        //         this.RTCConnections.get(user_id).addTrack(track, this.RTCAllTracks[i].stream)
                        //     }catch(error){
                        //         console.log(error)
                        //     }
                        // })
                    // }
                    if(this.RTCAllTracks[i].from_user != this.loggedInUserId){
                        this.RTCNotAcceptedTracks.push({
                            "from_user": this.RTCAllTracks[i].from_user,
                            "user_id": user_id,
                            "stream": this.RTCAllTracks[i].stream
                        })
                    }
                }
            }

            if(!join){
                this.RTCConnections.get(user_id).createOffer().then((desc) => {
                    // TODO: If check this guard, will only work with one call.
                    // the second call will have the wrong channel id
                    // if(this.callChannelId == null){
                    //     this.callChannelId = SessionManager.getActiveChannelId()
                    // }
                    this.callChannelId = SessionManager.getActiveChannelId()
                    // memorization
                    this.RTCDesc.set(user_id, desc)
                    SignalingServer.CreateCall(this.loggedInUserId,
                                                this.callChannelId,
                                                user_id,
                                                desc,
                                                this.callUserIds,
                                                [user_id])
                })
            }else {
                /**CASE JOIN */

                this.RTCConnections.get(user_id).createOffer().then((desc) => {
                    this.RTCDesc.set(user_id, desc)
                    SignalingServer.JoinCall(this.loggedInUserId,
                                            this.callChannelId,
                                            user_id, // @TODO here check
                                            desc,
                                            this.callUserIds,
                                            [user_id])

                })

                for(let i = 0; i < this.RTCAllTracks.length;i++){
                    if(this.RTCAllTracks[i].from_user != user_id){
                        this.RTCNotAcceptedTracks.push({
                            "from_user": this.RTCAllTracks[i].from_user,
                            "user_id": user_id,
                            "stream": this.RTCAllTracks[i].stream
                        })
                    }
                }

            }

            this.RTCConnections.get(user_id).ontrack =  (e) => {
                this.track(e, user_id)
            }
        },
        CleanRemoveUser(user_id){
            if(this.callUserIds.indexOf(user_id) > -1){
                this.callUserIds.splice(this.callUserIds.indexOf(user_id), 1)
                if(this.callUserIds.length == 0){
                    this.DeclineCall()
                }
            }
            if(this.RTCConnections.has(user_id)){
                this.RTCConnections.get(user_id).close()
                this.RTCConnections.delete(user_id)
            }

            if(this.RTCDesc.has(user_id)){
                this.RTCDesc.delete(user_id)
            }

            for(let i=0;i <this.RTCAllTracks.length;i++){
                if(this.RTCAllTracks[i].from_user == user_id){
                    this.RTCAllTracks.splice(i, 1)
                }
            }

            for(let i=0; i < this.RTCNotAcceptedTracks.length;i++){
                if(this.RTCNotAcceptedTracks[i].from_user == user_id){
                    this.RTCNotAcceptedTracks.splice(i, 1)
                }
            }

            SignalingServer.RemoveUserFromCall(this.loggedInUserId, user_id, this.callUserIds)
            Global.globalValue("CALL_REMOVE_USER", user_id)
        },
        ResetCallData(){
            this.callState = 'none'
            this.allowVideo =  false
            this.microphoneMuted =  false
            this.RTCConnections = new Map()
            this.RTCDesc = new Map()
            this.RTCNotAcceptedTracks = []
            this.RTCAllTracks= []
            this.callUserIds = []
            this.callTime = 0
            this.elapsedTime = "00:00"
            this.localVideoStream = null
            this.localAudioStream =  null
        },
        CheckTracks(user_id){
            console.log("----------------------")
            console.log("tracks for  "  + SessionManager.getUser(user_id).username)
            for(let i = 0; i < this.RTCNotAcceptedTracks.length;i++){
                if(this.RTCNotAcceptedTracks[i].user_id == user_id){
                    console.error(this.RTCNotAcceptedTracks[i].stream.getTracks().length)
                    this.RTCNotAcceptedTracks[i].stream.getTracks().forEach(track => {
                        try {
                            this.RTCConnections.get(user_id).addTrack(track, this.RTCNotAcceptedTracks[i].stream)
                            this.RTCConnections.get(user_id).createOffer().then((desc) => {
                                this.RTCDesc.set(user_id, desc)
                                SignalingServer.UpgradeCall(this.loggedInUserId,
                                        this.RTCNotAcceptedTracks[i].from_user,
                                        desc,
                                        [user_id])
                                        return
                                // this.RTCNotAcceptedTracks.splice(i, 1)
                            })
                        } catch (error) {
                            console.log(error)
                            // this.RTCNotAcceptedTracks.splice(i, 1)
                            // return
                        }

                    })
                    break
                }
            }
        },
        getRootWindow(window){
            if(window.parent === window){
                return window
            }
            return this.getRootWindow(window.parent)
        },
    },
}
